"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInvoiceLink = exports.getOrganizationBaseURL = exports.getCurrentAppServerURI = exports.getCurrentAPIServerURI = void 0;
const getCurrentAPIServerURI = (appConfig, useLocal = false) => {
    if (useLocal && appConfig.PRACTICE_ENV === "local")
        return "http://localhost:3004";
    return `https://${appConfig.PRACTICE_API_URL}`;
};
exports.getCurrentAPIServerURI = getCurrentAPIServerURI;
const getCurrentAppServerURI = (appConfig) => {
    if (appConfig.PRACTICE_ENV === "local") {
        return "http://localhost:3000";
    }
    return `https://${appConfig.PRACTICE_APP_URL}`;
};
exports.getCurrentAppServerURI = getCurrentAppServerURI;
const getOrganizationBaseURL = (appUrl, organization) => {
    if (organization.domains &&
        organization.domains.useCustomDomain &&
        organization.domains.domainName) {
        return `https://${organization.domains.domainName}`;
    }
    const slug = typeof organization === "string"
        ? organization
        : organization.slug || organization.id;
    return `${appUrl}/me/${slug}`;
};
exports.getOrganizationBaseURL = getOrganizationBaseURL;
function buildInvoiceLink(appUrl, organization, invoiceId) {
    const baseUrl = (0, exports.getOrganizationBaseURL)(appUrl, organization);
    return `${baseUrl}/invoices/${invoiceId}`;
}
exports.buildInvoiceLink = buildInvoiceLink;
//# sourceMappingURL=links.js.map